/* istanbul ignore file */
import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";

import { ISecurityRolesRequest, ISecurityRolesResponse } from "./SecurityRoles.api.types";

export const getSecurityRoles = async (request: ISecurityRolesRequest): Promise<ISecurityRolesResponse[]> => {
  return (
    await getClientFor(mainApi.name).get(`/security-roles/details/tenants/${request.tenantId}`, {
      params: {
        accountId: request.accountId
      }
    })
  ).data;
};
